/* global  */ // tUrl等のグローバル変数を宣言する

// import scrollLock from './functions/_scrollLock.js' // スクロールロック
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######
const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    // scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    // scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

/*
########    ###    ########
   ##      ## ##   ##     ##
   ##     ##   ##  ##     ##
   ##    ##     ## ########
   ##    ######### ##     ##
   ##    ##     ## ##     ##
   ##    ##     ## ########
*/
//任意のタブにURLからリンクするための設定
function GethashID(hashIDName) {
  if (hashIDName) {
    //タブ設定
    $('.workContent__tab-area li')
      .find('a')
      .each(function () {
        //タブ内のaタグ全てを取得
        var idName = $(this).attr('href') //タブ内のaタグのリンク名（例）#lunchの値を取得
        if (idName == hashIDName) {
          //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
          var parentElm = $(this).parent() //タブ内のaタグの親要素（li）を取得
          $('.workContent__tab-area li').removeClass('active') //タブ内のliについているactiveクラスを取り除き
          $(parentElm).addClass('active') //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
          //表示させるエリア設定
          $('.workContent__main-area').removeClass('is-active') //もともとついているis-activeクラスを取り除き
          $(hashIDName).addClass('is-active') //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加
        }
      })
  }
}

//タブをクリックしたら
$('.workContent__tab-area a').on('click', function () {
  var idName = $(this).attr('href') //タブ内のリンク名を取得
  GethashID(idName) //設定したタブの読み込みと
  return false //aタグを無効にする
})

// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
  $('.workContent__tab-area li:first-of-type').addClass('active') //最初のliにactiveクラスを追加
  $('.workContent__main-area:first-of-type').addClass('is-active') //最初の.areaにis-activeクラスを追加
  var hashName = location.hash //リンク元の指定されたURLのハッシュタグを取得
  GethashID(hashName) //設定したタブの読み込み
})

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

/*
        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##
*/
/*
         ##     ## ##     ##
         ###   ### ##     ##
         #### #### ##     ##
 ####### ## ### ## ##     ##
         ##     ##  ##   ##
         ##     ##   ## ##
         ##     ##    ###
*/

if (document.getElementById('mvSlide')) {
  // Swiperコンテナを検出したら実行
  const slideItem = document.getElementById('mvSlide')
  // eslint-disable-next-line no-unused-vars
  const mvSlideSwiper = new Swiper(slideItem, {
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    preloadImages: true, // スライド内の画像を読み終えてから開始
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
    },
  })
}

/*
        #### ##    ## ######## ######## ########  ##     ## #### ######## ##      ##
         ##  ###   ##    ##    ##       ##     ## ##     ##  ##  ##       ##  ##  ##
         ##  ####  ##    ##    ##       ##     ## ##     ##  ##  ##       ##  ##  ##
#######  ##  ## ## ##    ##    ######   ########  ##     ##  ##  ######   ##  ##  ##
         ##  ##  ####    ##    ##       ##   ##    ##   ##   ##  ##       ##  ##  ##
         ##  ##   ###    ##    ##       ##    ##    ## ##    ##  ##       ##  ##  ##
        #### ##    ##    ##    ######## ##     ##    ###    #### ########  ###  ###
*/

if (document.getElementById('intSlide')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('intSlide')
  const sliderName = 'intSlide'
  const intSlideSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（intSlideSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
    preloadImages: true, // スライド内の画像を読み終えてから開始
    // slidesPerView: 5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    // spaceBetween: 20, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたらオート解除
    },
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
    },
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      769: {
        slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        spaceBetween: 10, //スライド同士の間隔を空ける
      },
      1000: {
        slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        spaceBetween: 20, //スライド同士の間隔を空ける
      },
    },
  })
}
